import { ContactClass, ContactType } from 'app/utility/enums';
import { PopoverController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    template: `
    <ion-list class="ion-no-margin">
      @if (show('customer-individual')) {
        <ion-item (click)="executeAction('customer-individual')">
          <span>Add customer - individual</span>
        </ion-item>
      }
      @if (show('customer-company')) {
        <ion-item (click)="executeAction('customer-company')">
          <span>Add customer - company</span>
        </ion-item>
      }
      @if (show('supplier-individual')) {
        <ion-item (click)="executeAction('supplier-individual')">
          <span>Add supplier - individual</span>
        </ion-item>
      }
      @if (show('supplier-company')) {
        <ion-item (click)="executeAction('supplier-company')">
          <span>Add supplier - company</span>
        </ion-item>
      }
    </ion-list>
    `,
    standalone: false
})
export class SelectContactSearchPopover
{

	@Input() contactClass: ContactClass;
	@Input() contactType: ContactType;


	constructor(private popoverCtrl: PopoverController)
	{

	}

	show(type: string)
	{
		switch (type)
		{
			case "customer-individual":
				if (this.contactClass == ContactClass.Business) return false;
				if (this.contactType == ContactType.Supplier) return false;
				break;
			case "customer-company":
				if (this.contactClass == ContactClass.Individual) return false;
				if (this.contactType == ContactType.Supplier) return false;
				break;
			case "supplier-individual":
				if (this.contactClass == ContactClass.Business) return false;
				if (this.contactType == ContactType.Customer) return false;
				break;
			case "supplier-company":
				if (this.contactClass == ContactClass.Individual) return false;
				if (this.contactType == ContactType.Customer) return false;
				break;

		}
		return true;
	}
	ngOnInit()
	{

	}

	async onDismiss($event)
	{
		try
		{
			await this.popoverCtrl.dismiss({});
		} catch (e)
		{
			//click more than one time popover throws error, so ignore...
		}

	}

	async executeAction(action)
	{
		try
		{
			await this.popoverCtrl.dismiss({ action: action });
		}
		catch (e)
		{
			//click more than one time popover throws error, so ignore...
		}
	}
}